import React, { createContext, useContext, useMemo, useState } from "react";
import { wrapperMap } from "./controlWrappers";
import "../../assets/css/revised_css/components/controlManagerThemes/controlManager.css"
import { Col, Container, Row } from "react-bootstrap";
import useScrollPercentage from "../scripts/useScrollPercentage";


export const ControlWrapperContext = createContext(null)

export function ControlWrapperProvider({ children, options = {}, objectMetadata, onSubmit,  }) {
  const [settings, setSettings] = useState({})
  const scrollState = useScrollPercentage()

  const [childContainerRef] = scrollState

  const { HeaderWrapper, BodyWrapper, ContainerWrapper} = useMemo(() => {
    const modules = options.modules || {}
    return {
      HeaderWrapper: modules.header || EmptyWrap,
      BodyWrapper: modules.body || EmptyWrap,
      ContainerWrapper: modules.container || EmptyWrap
    }
  }, [options, objectMetadata])
  const [controlHeader, setControlHeader] = useState([])
  const bodyColWidth = useMemo(() => ({ 
    wrapper:  options.modules && options.modules.body ? 3 : 0, 
    body:  options.modules && options.modules.body ? 9 : 12 }), [BodyWrapper])

  return (
    <ControlWrapperContext.Provider value={{ setControlHeader, settings, setSettings }}>
      <ContainerWrapper options={options} objectMetadata={objectMetadata} onSubmit={onSubmit}>
        <HeaderWrapper childContainerRef={childContainerRef} objectMetadata={objectMetadata} settings={settings} setSettings={setSettings} >{controlHeader}</HeaderWrapper>
        <Row className="con-man-wrapper g-0">
          <Col sm={bodyColWidth.wrapper} className="con-man-wrapper">
            {BodyWrapper ? (
              <BodyWrapper objectMetadata={objectMetadata} scrollState={scrollState} settings={settings} setSettings={setSettings}/>
            ) : []}
          </Col>
          <Col sm={bodyColWidth.body} className="con-man-wrapper">
            <Container ref={childContainerRef} className="control-manager-child-container">
              {children}
            </Container>
          </Col>
        </Row>
      </ContainerWrapper>

    </ControlWrapperContext.Provider>
  )
}

function EmptyWrap({ children }) {
  return children || null
}


export function useControlHeaderContext() { return useContext(ControlWrapperContext) }